import axios from 'axios'
import { config } from "../Config/config"

const darahService = {
    getAll: () => {
        const result = axios.get(config.apiUrl + '/darah')
        //ketika berhasil 
        .then(respon => {
            return{
                success : respon.data.success,
                result : respon.data.result
            }
        })
        //untuk pesan errornya
        .catch(error => {
            return {
                success : false,
                error : error
            }
        })
        return result
    },
    getFilter: (filter) => {
        const result = axios.post(config.apiUrl + '/darahFilter', filter)
            //ketika berhasil 
            .then(respon => {
                // console.log(respon.data)
                return {
                    success: respon.data.success,
                    result: respon.data.result
                }
            })
            //untuk pesan errornya
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },
    addData:(data) => {
        const result = axios.post(config.apiUrl + '/darah', data)
        .then(respon=> {
            return{
                success : respon.data.success,
                result : respon.data.result
            }
        })
        .catch(error => {
            return {
                success : false,
                error : error
            }
        })
        return result
    },
    EditData :(data) => {
        const result = axios.put(config.apiUrl + '/darah', data)
        .then(respon=> {
            return{
                success : respon.data.success,
                //untuk mengeluarkan isi yang ada di dalam array
                result : respon.data.result
            }
        })
        .catch(error => {
            return {
                success : false,
                error : error
            }
        })
        return result
    },
    EditDDelete :(data) => {
        const result = axios.put(config.apiUrl + '/darahDelete', data)
        .then(respon=> {
            return{
                success : respon.data.success,
                //untuk mengeluarkan isi yang ada di dalam array
                result : respon.data.result
            }
        })
        .catch(error => {
            return {
                success : false,
                error : error
            }
        })
        return result
    },
    DeleteData :(id) => {
        const result = axios.delete(config.apiUrl + '/darah/' + id)
        .then(respon=> {
            return{
                success : respon.data.success,
                //untuk mengeluarkan isi yang ada di dalam array
                result : respon.data.result
            }
        })
        .catch(error => {
            return {
                success : false,
                error : error
            }
        })
        return result
    },
    getById :(id) => {
        const result = axios.get(config.apiUrl + '/darahById/' + id)
        .then(respon=> {
            return{
                success : respon.data.success,
                //untuk mengeluarkan isi yang ada di dalam array
                result : respon.data.result[0]
            }
        })
        .catch(error => {
            return {
                success : false,
                error : error
            }
        })
        return result
    }

}

export default darahService